import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import Constants from 'expo-constants';
import * as ExpoFileLogger from'expo-file-logger';

const LoggedComponent = props => {
    const [ start, setStart ] = useState();

    if (Platform.OS.equals('web') && (__DEV__ || Constants.expoConfig.extra.enablePerformanceLogging === 'true') && !start) {
        setStart(performance.now());
    }
    
    useEffect(() => {
        if (Platform.OS.equals('web') && (__DEV__ || Constants.expoConfig.extra.enablePerformanceLogging === 'true')) {
            const duration = ((performance.now() - start) / 1000);

            console.log(`Component [${props.name}] mounting took ${duration}s, cacheHit=${props.cacheHit || false}`);
        }

        ExpoFileLogger.log(
            'debug', 
            `Component [${props.name}] was mounted`
        );

        return () =>  
            ExpoFileLogger.log(
                'debug', 
                `Component [${props.name}] was unmounted`
            );
    }, [ props.name ]);

    return (
        props.children
    );
};

export default LoggedComponent;
